import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ReadCustomCode, UpdateCustomCode } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { CustomCodeScope, customCodesQueryKey, invalidatePackagedPreviews } from './custom-codes-query-key';

export type PatchCustomCodeParams = {
  scope: CustomCodeScope;
  codeId: string;
  data: UpdateCustomCode;
};

export const patchCustomCode = async (
  params: PatchCustomCodeParams,
): Promise<ReadCustomCode> => {
  return await tinctApi.customCodes.patchCustomCode(
    params.scope,
    params.codeId,
    params.data,
  );
};

export const usePatchCustomCode = (
  options?: Omit<
    UseMutationOptions<ReadCustomCode, ApiError, PatchCustomCodeParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchCustomCode,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: customCodesQueryKey(args[1].scope),
      });
      invalidatePackagedPreviews(queryClient);
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
